import React, { useState, useEffect } from 'react';
import api from '../../api/api';
import ClientLayout from '../../components/ClientLayout';
import { useNavigate } from 'react-router-dom';

// --- CONFIGURACIÓN ESTÉTICA ---
const COLORS = { 
    green: '#2E5B2E', 
    pink: '#C19A6B', 
    cream: '#F9F9F5', 
    dark: '#1F2937', 
    white: '#FFFFFF',
    border: '#E5E7EB',
    danger: '#EF4444'
};

const STATUS_STYLES = {
    'SOLICITADO': { bg: '#FEF3C7', color: '#D97706', label: '⏳ Solicitado' },
    'CONFIRMADO': { bg: '#DBEAFE', color: '#2563EB', label: '✅ Confirmado' },
    'EN_RUTA': { bg: '#E0E7FF', color: '#4F46E5', label: '🚚 En Ruta' },
    'ENTREGADO': { bg: '#D1FAE5', color: '#059669', label: '🏁 Entregado' },
    'CANCELADO': { bg: '#FEE2E2', color: '#DC2626', label: '❌ Cancelado' }
};

function HistorialPedidos() {
    const navigate = useNavigate();
    const [pedidos, setPedidos] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // --- FILTROS ---
    const [filter, setFilter] = useState('TODOS');
    const [fechaDesde, setFechaDesde] = useState('');
    const [fechaHasta, setFechaHasta] = useState('');

    const fetchPedidos = async () => {
        setLoading(true);
        const token = localStorage.getItem('token');
        try {
            const { data } = await api.get(`/pedidos?limit=100`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setPedidos(data.data || []); 
        } catch (error) {
            console.error("Error historial:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchPedidos(); }, []);

    // --- LÓGICA DE FILTRADO ---
    const filteredPedidos = pedidos.filter(p => {
        let pasaEstado = true;
        if (filter === 'ACTIVOS') pasaEstado = ['SOLICITADO', 'CONFIRMADO', 'EN_RUTA'].includes(p.estado);
        else if (filter !== 'TODOS') pasaEstado = p.estado === filter;

        const fechaPedido = (p.fechaEntrega || p.createdAt).split('T')[0];
        let pasaFecha = true;
        if (fechaDesde && fechaPedido < fechaDesde) pasaFecha = false;
        if (fechaHasta && fechaPedido > fechaHasta) pasaFecha = false;

        return pasaEstado && pasaFecha;
    });

    const renderStatus = (estado) => {
        const style = STATUS_STYLES[estado] || STATUS_STYLES['SOLICITADO'];
        return (
            <span style={{ 
                background: style.bg, color: style.color, 
                padding: '4px 12px', borderRadius: 20, fontSize: 11, fontWeight: 'bold', whiteSpace: 'nowrap'
            }}>
                {style.label}
            </span>
        );
    };

    // --- ESTILOS DE TABLA ---
    const thStyle = { padding: '15px', textAlign: 'left', borderBottom: `2px solid ${COLORS.border}`, color: '#6B7280', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.5px' };
    const tdStyle = { padding: '15px', borderBottom: `1px solid ${COLORS.border}`, color: COLORS.dark, fontSize: 13, verticalAlign: 'middle' };
    const inputStyle = { padding: '8px', borderRadius: '8px', border: `1px solid ${COLORS.border}`, fontSize: '13px', outline: 'none', color: COLORS.dark, background: '#fff' };
    const btnFilter = (f) => ({ padding: '8px 16px', borderRadius: 20, border: 'none', cursor: 'pointer', fontWeight: 'bold', fontSize: 13, background: filter === f ? COLORS.green : COLORS.white, color: filter === f ? COLORS.white : '#6B7280', boxShadow: filter === f ? '0 4px 6px rgba(0,0,0,0.1)' : 'none', transition: '0.2s' });

    return (
        <ClientLayout title="Mis Pedidos Xavana">
            <div style={{ maxWidth: 1200, margin: '0 auto' }}>
                
                {/* BARRA DE FILTROS */}
                <div style={{ background: 'white', padding: '20px', borderRadius: '12px', marginBottom: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end', flexWrap: 'wrap', gap: '20px' }}>
                        
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <label style={{ fontSize: '10px', fontWeight: 'bold', color: '#6B7280' }}>ESTADO</label>
                            <div style={{ display: 'flex', gap: 10, background: '#E5E7EB', padding: 5, borderRadius: 25 }}>
                                <button onClick={() => setFilter('TODOS')} style={btnFilter('TODOS')}>Todos</button>
                                <button onClick={() => setFilter('ACTIVOS')} style={btnFilter('ACTIVOS')}>🚚 En Curso</button>
                                <button onClick={() => setFilter('ENTREGADO')} style={btnFilter('ENTREGADO')}>🏁 Entregados</button>
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '10px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <label style={{ fontSize: '10px', fontWeight: 'bold', color: '#6B7280' }}>DESDE</label>
                                <input type="date" value={fechaDesde} onChange={(e) => setFechaDesde(e.target.value)} style={inputStyle} />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <label style={{ fontSize: '10px', fontWeight: 'bold', color: '#6B7280' }}>HASTA</label>
                                <input type="date" value={fechaHasta} onChange={(e) => setFechaHasta(e.target.value)} style={inputStyle} />
                            </div>
                        </div>

                        <button 
                            onClick={() => { setFechaDesde(''); setFechaHasta(''); setFilter('TODOS'); }}
                            style={{ background: '#F3F4F6', color: '#6B7280', border: 'none', padding: '10px 15px', borderRadius: 8, cursor: 'pointer', fontSize: '13px' }}
                        >
                            Limpiar Filtros
                        </button>
                    </div>
                </div>

                {/* TABLA DE HISTORIAL */}
                <div style={{ background: COLORS.white, borderRadius: 12, boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', overflowX: 'auto' }}>
                    {loading ? (
                        <div style={{ padding: 40, textAlign: 'center' }}>Cargando historial...</div>
                    ) : (
                        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '900px' }}>
                            <thead>
                                <tr>
                                    <th style={thStyle}>Folio / Solicitud</th>
                                    <th style={thStyle}>Sucursal</th>
                                    <th style={thStyle}>Entrega Real</th>
                                    <th style={thStyle}>Producto / Cantidad</th>
                                    <th style={thStyle}>Monto</th>
                                    <th style={thStyle}>Estado</th>
                                    <th style={thStyle}>Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredPedidos.map(p => (
                                    <tr key={p.id} style={{ transition: 'background 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F9FAFB'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                                        {/* Folio y Solicitud */}
                                        <td style={tdStyle}>
                                            <div style={{ fontWeight: 'bold', fontFamily: 'monospace', color: p.folioRecibo ? COLORS.pink : COLORS.dark }}>
                                                {p.folioRecibo || `...${p.id.slice(-6)}`}
                                            </div>
                                            <div style={{ fontSize: 11, color: '#6B7280' }}>
                                                Solicitud: {new Date(p.createdAt).toLocaleDateString('es-MX')}
                                            </div>
                                        </td>

                                        {/* Sucursal */}
                                        <td style={tdStyle}>
                                            <div style={{ fontWeight: '600' }}>{p.sucursal?.nombre || 'General'}</div>
                                            <div style={{ fontSize: 11, color: '#6B7280', maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {p.sucursal?.direccion || 'Entrega en oficina'}
                                            </div>
                                        </td>

                                        {/* Entrega Real (Basada en Folio) */}
                                        <td style={tdStyle}>
                                            {p.folioRecibo ? (
                                                <div style={{ color: COLORS.green, fontWeight: 'bold' }}>
                                                    {(() => {
                                                        const partes = p.folioRecibo.split('-');
                                                        const diaMes = partes[2];
                                                        return `${diaMes.substring(0, 2)}/${diaMes.substring(2, 4)}/20${partes[1]}`;
                                                    })()}
                                                </div>
                                            ) : (
                                                <div style={{ color: '#9CA3AF', fontSize: 12 }}>
                                                    {p.fechaEntrega ? `Est: ${new Date(p.fechaEntrega).toLocaleDateString('es-MX')}` : 'Pendiente'}
                                                </div>
                                            )}
                                        </td>

                                        {/* Producto */}
                                        <td style={tdStyle}>
                                            <div style={{ fontWeight: '500' }}>{p.tipoProducto?.replace(/_/g, ' ')}</div>
                                            <div style={{ fontSize: 11, color: COLORS.green, fontWeight: 'bold' }}>
                                                {(Number(p.cantidadGrano) + Number(p.cantidadMolido))} Kg Total
                                            </div>
                                        </td>

                                        {/* Monto y Receptor */}
                                        <td style={tdStyle}>
                                            <div style={{ fontWeight: 'bold' }}>${Number(p.montoTotal).toLocaleString('es-MX')}</div>
                                            {p.recibidoPor && (
                                                <div style={{ fontSize: 10, color: '#6B7280' }}>
                                                    👤 {p.recibidoPor}
                                                </div>
                                            )}
                                        </td>

                                        {/* Estado */}
                                        <td style={tdStyle}>{renderStatus(p.estado)}</td>

                                        {/* Acciones */}
                                        <td style={tdStyle}>
                                            <button 
                                                onClick={() => navigate(`/pedidos/${p.id}`)}
                                                style={{ 
                                                    background: 'transparent', 
                                                    border: `1px solid ${COLORS.border}`, 
                                                    color: COLORS.green, 
                                                    padding: '6px 12px', 
                                                    borderRadius: 8, 
                                                    cursor: 'pointer',
                                                    fontSize: 12,
                                                    fontWeight: 'bold',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Ver Ticket
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                    {!loading && filteredPedidos.length === 0 && (
                        <div style={{ padding: 40, textAlign: 'center', color: '#9CA3AF' }}>No se encontraron pedidos con estos filtros.</div>
                    )}
                </div>
            </div>
        </ClientLayout>
    );
}

export default HistorialPedidos;